export const HoneypotField = () => (
  <div className="absolute -left-[9999px] top-auto w-px h-px overflow-hidden" aria-hidden="true">
    <label htmlFor="website">Ne pas remplir ce champ</label>
    <input id="website" name="website" type="text" tabIndex={-1} autoComplete="off" defaultValue="" data-testid="honeypot-field" />
  </div>
);

export const readHoneypot = (e) => e.currentTarget?.elements?.website?.value || "";

export const submitErrorMessage = (error) => {
  const status = error?.response?.status;
  const detail = error?.response?.data?.detail;
  if (status === 429 || status === 413 || (status === 400 && typeof detail === "string")) return detail;
  return "Erreur lors de l'envoi. Veuillez réessayer.";
};

export default HoneypotField;
